import {resolveBackground} from '#core/utils/color-utils.js';

import {constructTilePalette} from '#core/application/modules/tiles-cache.js';
import {generateBetBuilderSelectionItem} from '#core/application/modules/tiles/bet-builder-selection-item/index.js';

export function bettingCenterFactory(PALETTE) {
    const {FONT} = PALETTE;
    const BASE_BUTTON = {
        padding: '0 8px',
        height: '40px', // important to have height here since height 100% doesn't work on some elements (such as betslip tabs)
        alignItems: 'center',
        fontSize: FONT.SIZE_MEDIUM,
        fontWeight: FONT.WEIGHT_SEMI_BOLD,
        whiteSpace: 'nowrap', // only Solverde have long PT translation here
    };

    return {
        BettingCenterView: {
            tabs: {
                container: {
                    style: {
                        minHeight: '100%',
                    },
                },
                tabButtons: {
                    container: {
                        style: {
                            _desktop_alignItems: 'center',
                        },
                    },
                    selectableButton: {
                        selected: {
                            style: {
                                base: {
                                    ...BASE_BUTTON,
                                    ...PALETTE.BETTING_CENTER_TAB_BUTTON_SELECTED_TEXT,
                                    ...resolveBackground(PALETTE.BETTING_CENTER_TAB_BUTTON_SELECTED_BG),
                                },
                            },
                        },
                        unselected: {
                            style: {
                                base: {
                                    ...BASE_BUTTON,
                                    ...PALETTE.BETTING_CENTER_TAB_BUTTON_TEXT,
                                    ...resolveBackground(PALETTE.BETTING_CENTER_TAB_BUTTON_BG),
                                },
                            },
                        },
                        indicator: {
                            style: {
                                base: {
                                    height: 0,
                                    backgroundColor: 'transparent',
                                },
                            },
                        },
                    },
                },
            },
            container: {
                style: PALETTE.BETTING_CENTER_SHOW_BOX_SHADOW
                    ? {_desktop_boxShadow: PALETTE.BETTING_CENTER_BOX_SHADOW}
                    : {},
            },
        },
        // have to store it here because Moj don't pass nested config to all MatchAccaSelectionItem (look at leg-view.jsx or open-bet.jsx)
        // TODO: replace with explicit configuration when MOJ-15826 is delivered
        MatchAccaSelectionItem: generateBetBuilderSelectionItem(
            constructTilePalette('BET_BUILDER_SELECTION_ITEM', null, PALETTE.BETTING_CENTER_BET_CONTAINER_BG)
        ),
    };
}
